import styled from 'styled-components'
import {getStatusColor} from 'shared/utils/statusUtils'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		padding: 12px;
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		border: 1px solid ${({theme}) => theme.color.grey3 || '#DFDFE7'};
		border-radius: 16px;
	`,

	Header: styled.div`
		display: flex;
		align-items: center;
		gap: 4px;
		width: 100%;
	`,

	SectionTitle: styled.h3`
		${({theme}) => theme.font.medium_bold || theme.font.medium};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 16px;
		font-weight: 700;
		line-height: 1.2;
		margin: 0;
		flex: 1;
	`,

	ContentContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
		width: 100%;
	`,

	NameRow: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 6px;
		width: 100%;
		min-height: 14px;
	`,

	TournamentName: styled.span`
		${({theme}) => theme.font.small_bold || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		flex: 1;
	`,

	StatusBadge: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 6px;
		background-color: ${({statusColor, theme}) =>
			getStatusColor(statusColor, theme)};
		border-radius: 99px;
		flex-shrink: 0;
		width: fit-content;
	`,

	StatusText: styled.span.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({statusColor, theme}) =>
			statusColor === 'default'
				? theme.color.black || '#1F2024'
				: theme.color.white || '#FFFFFF'};
		font-size: 8px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
	`,

	InfoRow: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	`,

	Label: styled.p`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.grey4 || '#8D8D8D'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		flex-shrink: 0;
	`,

	Value: styled.p`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		text-align: right;
		word-break: break-all;
		cursor: ${({title}) => (title ? 'help' : 'default')};
	`,
}

export default Style
